import './SiteFooter.css';

export default function SiteFooter({ className = '', as: Element = 'footer', compact = false }) {
  return <Element className={`site-footer ${className}`} data-compact={compact ? 'true' : undefined}>
    <span><span className="site-footer__intro">© Design, innovation and technology by{' '}</span>
      <a href="http://inovatech.digital/" target="_blank" rel="noopener noreferrer">InovaTech</a>
    </span>
  </Element>;
}
